import type { ComponentType, ReactNode } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { themeColors } from '../../../../theme'
import { CARD_SHADOW } from './cardStyles'

const MotionBox = motion.create(Box)
const colors = themeColors

interface Props {
  title: string
  subtitle?: string
  icon?: ComponentType<{ size?: number; color?: string }>
  /** Color de acento para el chip del icono. */
  accent?: string
  /** Contenido alineado a la derecha del header (badges, toggles). */
  action?: ReactNode
  delay?: number
  /** Quita el padding del cuerpo (p.ej. para mapas/tablas a sangre). */
  noBodyPadding?: boolean
  children: ReactNode
}

export default function SectionCard({
  title,
  subtitle,
  icon: Icon,
  accent = '#1A7A4C',
  action,
  delay = 0,
  noBodyPadding = false,
  children,
}: Props) {
  return (
    <MotionBox
      bg={colors.bgPanel}
      border="1px solid"
      borderColor={colors.border}
      borderRadius="2xl"
      overflow="hidden"
      boxShadow={CARD_SHADOW}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
    >
      <Flex
        px={6}
        py={4}
        justifyContent="space-between"
        alignItems="center"
        gap={3}
        borderBottom="1px solid"
        borderColor={colors.border}
      >
        <Flex alignItems="center" gap={3} minW={0}>
          {Icon && (
            <Flex
              align="center"
              justify="center"
              w="34px"
              h="34px"
              borderRadius="lg"
              bg={`${accent}1A`}
              flexShrink={0}
            >
              <Icon size={17} color={accent} />
            </Flex>
          )}
          <Box minW={0}>
            <Text fontSize="md" fontWeight="bold" color={colors.text} fontFamily="heading" truncate>
              {title}
            </Text>
            {subtitle && (
              <Text
                fontSize="10px"
                textTransform="uppercase"
                letterSpacing="0.18em"
                fontWeight="bold"
                color={colors.textMuted}
                truncate
              >
                {subtitle}
              </Text>
            )}
          </Box>
        </Flex>
        {action && <Box flexShrink={0}>{action}</Box>}
      </Flex>
      <Box p={noBodyPadding ? 0 : 6}>{children}</Box>
    </MotionBox>
  )
}
